/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { advanceFrame, setTotalFrameCount } from 'redux/actions/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Ad from 'components/content/ad/ad';
import { batchActions } from 'redux-batched-actions';



/* ========== ~~~~~~~~~~ AD : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, sessionStatus, settings }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    sessionStatus: sessionStatus,
    embedSettings: settings.embedSettings,
    cookieCheckDone: sessionStatus.cookieCheckDone
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ad);